// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__9jN9-","svg":"styles_svg__CkKce"};